import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const expectedProgressCol = (gantt, t) => {
  const name = 'expected_progress';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.expectedProgress', 'Esperado Seguimiento'),
    align: 'center',
    resize: true,
    width: '*',
    template: (activity) => {
      const hasChild = gantt.hasChild(activity.id);
      const isOdd = gantt.oddColsConfig?.expected_progress || false;
      const lang = t('lang');

      const getOnClickHandler = (id) => {
        return activity.type === 'project'
          ? `onclick="window.to_use_react_gantt.showGanttAlert('${t('schedule_notification.calculated_column_value')}', ${id}, 'expected_progress', 'Calculated_Summary_Activity_Edit_Attempt')"`
          : '';
      };

      const getFormattedExpectedProgress = (progress, currentLang) => {
        if (progress?.toFixed) {
          return currentLang === 'en'
            ? `${progress.toFixed(2)}%`
            : `${progress.toFixed(2).replace('.', ',')}%`;
        }
        return '-% ';
      };

      const progressValue =
        activity.expected_progress !== undefined
          ? activity.expected_progress
          : null;
      
      const displayProgress = progressValue !== null 
        ? getFormattedExpectedProgress(progressValue, lang)
        : '-% ';

      return `
        <div 
          class="${isOdd ? 'odd-col' : 'non-odd-col'}" 
          style="font-weight: ${hasChild ? 600 : 100};" 
          ${getOnClickHandler(activity.id)}
        >
          ${displayProgress}
        </div>
      `;
    },
    hide: !isVisible,
    data_type: 'number',
    groupable: false,
    orderable: true,
    orderable_switch: ['1 → 9', '9 → 1'],
    filterable: false,
  };
};

export default expectedProgressCol; 